import { Star, Truck } from 'lucide-react';
import { Button } from '../ui/Button';

export function HeroSection() {
  return (
    <section id="hero" className="hero-section" aria-labelledby="hero-title">
      <picture className="hero-visual">
        <source type="image/webp" srcSet="/assets/homepage/hero/homepage-hero-bg.webp" />
        <img
          src="/assets/homepage/hero/homepage-hero-bg.png"
          alt="Prémiový stolní kalendář Calendar Studio s mobilní aplikací a dárkovým balením"
          className="hero-visual__image"
          loading="eager"
          fetchPriority="high"
        />
      </picture>
      <div className="hero-copy">
        <p className="eyebrow">Calendar Studio</p>
        <h1 id="hero-title">Tvůj rok<br />na zdi</h1>
        <p className="hero-subtitle">AI vybere, ty jen doladíš</p>
        <p className="hero-text">Umělá inteligence vybere tvé nejlepší momenty, ty máš čas na podstatné.</p>
        <div className="hero-actions">
          <Button href="/start">Vytvořit kalendář</Button>
          <Button href="#products" variant="secondary">Prozkoumat produkty</Button>
        </div>
        <div className="hero-meta">
          <span><Star size={16} fill="currentColor" /> 4,9/5 z 4200+ hodnocení</span>
          <span><Truck size={16} /> Doprava zdarma od 999 Kč</span>
        </div>
      </div>
    </section>
  );
}
